import React from "react";
import PageHeader from "../PageHader/PageHeader";

import Footer from "../Footer";
import ContactForm from "./ContactForm";
const Contact = () => {
  const d = new Date();
  let year = d.getFullYear();
  return (
    <center>
      <PageHeader back="Back" text="Contact Me" />
      <div className="  mt-4  w-full md:p-0 lg:p-2 xl:p-2">
        <div className="flex flex-col  md:justify-center  lg:flex-row ">
          <div
            className="w-[100%] border-[6px] border-[#17A6DB] dark:border-[#30dada] rounded-[64px] md:w-[100%] lg:ml-[64px] lg:w-[50%]"
           
          >
            <ContactForm />
          </div>

          <div className=" mt-4  lg:w-[50%] lg:mt-0 lg:ml-4">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1944.1061010630813!2d77.70767855819008!3d12.95826901162038!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bae12311d899a9f%3A0x77bd7fbd533ae45a!2sSpice%20Garden%20Layout%2C%20Lakshminarayana%20Pura%2C%20AECS%20Layout%2C%20Chinnapanna%20Halli%2C%20Bengaluru%2C%20Karnataka%20560037!5e0!3m2!1sen!2sin!4v1664092309096!5m2!1sen!2sin"
              style={{ border: "4px solid shite" }}
              allowfullscreen=""
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
              title="myFrame"
              className=" w-[390px] h-[300px] md:w-[810px] md:h-[650px] lg:w-[850px] lg:h-[650px]"
            ></iframe>
          </div>
        </div>
      </div>
      <div className=" mt-[70px] md:mt-[40px] md:block lg:mt-[100px] ">
        <p className="text-[#17A6DB] dark:text-[#30dada] flex justify-center pb-4 md:pb-0">
          Developed and Design @{year} by Deepesh Kumar.
        </p>
        <Footer />
      </div>
    </center>
  );
};

export default Contact;
